<div id="trainingItemGroupPanelList">
    <app-panel-list [panelList]="trainingItemGroupsPanelListData"
    [noResultFound] = "noData" (selectedItems)="getSelectedItems($event)"
        [ifAdditionalItems]="true">
        <ng-template #templateRef let-data="dataVar">
            <div class="card">
                <div class="card-container">
                    <div class="grid">
                        <div class="col-fixed" style="width: 65%">
                            <div class="font-semibold mb-1">Training Item Group</div>
                            <div class="content-wrap">
                                {{ data?.displayName }}
                            </div>
                        </div>
                        <div class="col-fixed" style="width: 35%">
                            <div class="font-semibold mb-1">eQMS Scope(s)</div>
                            <div class="content-wrap" *ngFor="let scope of data?.eQMSScopeDisplayNames">
                                {{ scope }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </app-panel-list>
</div>